import { animated, useSpring } from '@react-spring/web';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useMeasure } from 'react-use';
import './ui.css';

interface CollapsibleProps {
  collapsed: boolean;
  children: ReactNode;
  onExpand?: () => void;
}

const Collapsible = (props: CollapsibleProps): ReactElement => {
  const { children, collapsed = false, onExpand } = props;
  const [ref, { height }] = useMeasure<HTMLDivElement>();
  const [isInitialAnimation, setInitialAnimation] = useState<boolean>(true);

  const [renderChildren, setRenderChildren] = useState<boolean>(!collapsed);
  useEffect(() => {
    if (collapsed === false) {
      setRenderChildren(true);
      if (onExpand) {
        onExpand();
      }
    }
  }, [collapsed, onExpand]);

  const springProps = useSpring({
    config: { tension: 300, friction: 30 },
    to: {
      opacity: collapsed ? 0 : 1,
      height: collapsed ? `0px` : `${height}px`,
      transform: collapsed ? `translateY(-20px)` : `translateY(0)`,
    },
    immediate: isInitialAnimation,
    onRest: () => {
      if (isInitialAnimation === true) {
        setInitialAnimation(false);
      }
      if (collapsed) {
        setRenderChildren(false);
      }
    },
  });

  return (
    <animated.div className="collapsed-wrapper" style={springProps}>
      <div ref={ref} style={{ height: 'auto' }}>
        {renderChildren && children}
      </div>
    </animated.div>
  );
};

export { Collapsible };
